module.exports = __webpack_public_path__ + "img/yuan1.c54283d3.png";